var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-button',{staticClass:"navbarButton",on:{"click":_vm.add}},[_c('md-icon',[_vm._v("post_add")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }